module.exports = __webpack_public_path__ + "img/map_car.9fb1e9d5.svg";